import { isCustomRole, isAnyAdmin, isEmployee } from 'permissions/v1/roles';
import {
  noPermissions,
  canList,
  canView,
  canCreate,
  canUpdate,
  canDestroy,
} from 'permissions/v1/index';

import { hasVisits, hasEmployeeSubmitIncomingVisits } from 'permissions/v1/preferences';

const permission = 'Visitor';

const list = (profile) =>
  isAnyAdmin(profile) ||
  isEmployee(profile) ||
  isCustomRole(profile) ||
  canList(permission, profile);
const view = (profile) => isAnyAdmin(profile) || canView(permission, profile);
const create = (profile) =>
  isAnyAdmin(profile) ||
  isEmployee(profile) ||
  isCustomRole(profile) ||
  canCreate(permission, profile);
const update = (profile) => isAnyAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAnyAdmin(profile) || canDestroy(permission, profile);
const incoming = (profile) => isAnyAdmin(profile) || hasEmployeeSubmitIncomingVisits(profile);

const permissions = (profile) => {
  if (!hasVisits(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
    incoming: incoming(profile),
  };
};

export default permissions;
